var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIDisease02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2683 28.6368C19.3909 27.5374 21.8644 23.6554 21.6239 19.3954C21.5209 17.6089 21.0399 15.8569 19.9405 13.8987C17.8793 10.2571 15.0622 6.61547 13.5162 2.83646C13.2757 2.25243 12.3825 2.25243 12.142 2.83646C10.5961 6.61547 7.74465 10.2571 5.71773 13.8987C4.44661 16.1317 4 18.0899 4 20.1512C4 25.8197 9.35932 30.2515 15.2683 28.6711V28.6368Z",
    fill: "#FFCC6E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1429_78149",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 15,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.0913V23.9087C17 24.5265 17.3784 25.0804 17.9535 25.3061L21.7417 26.7906C22.4527 27.0698 23.2414 27.0698 23.9524 26.7906L27.7406 25.3061C28.3157 25.0804 28.6941 24.5265 28.6941 23.9087V18.0913C28.6941 17.4735 28.3157 16.9196 27.7406 16.6939L23.9509 15.2094C23.2399 14.9302 22.4511 14.9302 21.7402 15.2094L17.9535 16.6939C17.3784 16.9196 17 17.4735 17 18.0913Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1429_78149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8463 27.2266L17 24.935V17.0703L22.8463 19.3618V27.2266Z",
    fill: "#E2E6EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8477 27.2266L28.6924 24.935V17.0703L22.8477 19.3618V27.2266Z",
    fill: "#D2D6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8463 14.7773L17 17.0689L22.8463 19.3604L28.6911 17.0689L22.8463 14.7773Z",
    fill: "#F4F6FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDisease02);
export default __webpack_public_path__ + "static/media/i_disease_02.f51f2af0153c9eb4d3ec019a478f57db.svg";
export { ForwardRef as ReactComponent };